import { EnvironmentUtils } from '@grandvisionhq/utils';

const getRating = (rating)=>{
    const features = EnvironmentUtils.getFeatures();
    if (!features.includes('STORE_RATINGS_STORE_GROUP')) {
        return;
    }
    if ((rating === null || rating === void 0 ? void 0 : rating.value) === undefined) {
        return;
    }
    return {
        value: rating.value,
        count: rating.count
    };
};

export { getRating };
//# sourceMappingURL=get-rating.js.map
